import React, { useEffect, useState, useContext } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import FooterNavButtons from '../shared-components/FooterNavButtons'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import RedAlert from '../ui-elements/RedAlert'
import Spinner from '../ui-elements/Spinner'
import SummaryCheckWindow from './SummaryCheckWindow'
import { subscribe } from '../utils/pubsub'
import Modal from '../ui-elements/Modal'
import YellowAlert from '../ui-elements/YellowAlert'
import GreenAlert from '../ui-elements/GreenAlert'
import { useTranslation } from 'react-i18next'


type Props = {
    checkPeriodId: string | undefined
    checklistProgress: ObjectStringKeyAnyValue | null
    thisCheckPeriodSignoff: ObjectStringKeyAnyValue | null
    thisChecklistPeriod?: ObjectStringKeyAnyValue
    thisChecklist?: ObjectStringKeyAnyValue
}

function ChecklistStatus({
    checkPeriodId,
    checklistProgress,
    thisCheckPeriodSignoff,
    thisChecklistPeriod,
    thisChecklist
}: Props) {

    const {
        tableData,
        isSignoffRequired,
        checkPeriodIdsForActiveCheckists,
        sendMessageToWebsocket
    } = useContext(GlobalContext)

    const { t } = useTranslation()
    const navigate = useNavigate()


    const inProgress = thisChecklistPeriod && thisChecklistPeriod.InProgress === 'True' ? true : false

    if (!thisChecklist) {
        //console.error(`⛔️ ChecklistStatus: thisChecklist is undefined`)
        return null
    }

    if (!thisChecklistPeriod) {
        //console.error(`⛔️ ChecklistStatus: thisChecklistPeriod is undefined`)
        return null
    }


    return <div className={`w-full flex flex-col`}>


    {checklistProgress && checklistProgress.total_answers === 0 &&
        <YellowAlert icon={true} alignment={'left'}>
           {t('Dashboard.ChecklistStatus.noQuestionsSetUp')}
        </YellowAlert>}

        {!isSignoffRequired && !inProgress &&
            <GreenAlert icon={true} alignment={'left'}>
                {t('Dashboard.ChecklistStatus.checklistCompleted')}
            </GreenAlert>}

        {isSignoffRequired && thisCheckPeriodSignoff  && !inProgress &&
            <GreenAlert icon={true} alignment={'left'}>
                {t('Dashboard.ChecklistStatus.checklistCompletedAndSignedOff')}
            </GreenAlert>}


   

        {isSignoffRequired && !thisCheckPeriodSignoff && checklistProgress && checklistProgress.total_answers > 0 && (checklistProgress.total_answers === checklistProgress.completed_answers) &&
            <YellowAlert icon={true} alignment={'left'} onClick={() => navigate(`/checklists/${checkPeriodId}/complete-checklist`)}>
                {t('Dashboard.ChecklistStatus.signoffRequired')}
            </YellowAlert>}

    </div>
}

export default ChecklistStatus